const theme = Object.freeze({
  uhf: {
    healthQueTitle: `HEALTH QUESTIONNAIRE`,
    healthQueText: `Please select a family member and fill in their medical questionnaire. This information will help us serve you better, hence please update this regularly to reflect your current health.`,
  },
  netwell: {},
});

export default theme;
